export const isShowingSideMenu = () => (window.innerWidth >= 1200);
